import React from 'react';
import '../styles.scss';
import { MachinesGroup } from '..';
import { Translate } from 'react-i18nify';
import styles from './PageHeader.module.scss';
import cn from 'classnames';
interface PageHeaderProps {
  machinesGroupsList?: MachinesGroup[];
  useOwnStyles?: boolean;
}

const PageHeaderBase: React.FunctionComponent<
  React.PropsWithChildren<PageHeaderProps>
> = ({ machinesGroupsList, useOwnStyles, children }) => {
  return (
    <div className={useOwnStyles ? styles.menuHeader : 'menu_header'}>
      <div className={useOwnStyles ? styles.appMenu : 'app_menu'}>
        <div className="d-flex align-items-center">
          <span
            className={
              useOwnStyles
                ? cn(styles.appMenuTitle, 'mr-1')
                : 'app_menu_title mr-1'
            }
          >
            {children}
          </span>
          {machinesGroupsList !== undefined && (
            <span
              className={
                useOwnStyles
                  ? cn(styles.appMenuTitlePill, 'primary')
                  : 'app_menu_title_pill primary'
              }
            >
              {machinesGroupsList.length}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default (props) => (
  <PageHeaderBase {...props} useOwnStyles={false}>
    <Translate value="groups" />
  </PageHeaderBase>
);

export const PageHeaderCustom = (props) => (
  <PageHeaderBase {...props} useOwnStyles={true} />
);
